import React from 'react';
import styled from 'styled-components';
import {isNil} from 'lodash';
import {oneDecimalValueRegex} from '../../../util/uiconstants';
import Label from '../BaseComponentWrappers/MotifLabel';
import FormField from '../BaseComponentWrappers/MotifFormField';
import Input from '../BaseComponentWrappers/MotifInput';

function TextInputBox(props) {
	const {
		styleName,
		placeholderText,
		type,
		value,
		onChange,
		onPaste,
		alwaysDisplayPlaceholder,
		suffix,
		...extraProps
	} = props;

	const intRegex = new RegExp(/^\d+$/);

	function isIntegerValue(value) {
		if (value) {
			return intRegex.test(value);
		} else {
			return true;
		}
	}

	function isDecimalValue(value) {
		if (value) {
			return oneDecimalValueRegex.test(value);
		} else {
			return true;
		}
	}

	function handleOnchange(evt) {
		const text = evt.currentTarget.value.toString().trim();
		switch (type?.toLowerCase()) {
			case 'integer': {
				if (!isIntegerValue(text)) {
					return false;
				}
				break;
			}
			case 'decimal': {
				if (!isDecimalValue(text)) {
					return false;
				}
				break;
			}
		}
		onChange && onChange(evt);
	}

	function handleOnPaste(evt) {
		const text = evt.clipboardData.getData('text');

		switch (type?.toLowerCase()) {
			case 'integer': {
				if (!isIntegerValue(text)) {
					evt.preventDefault();
					return false;
				}
				break;
			}
			case 'decimal': {
				if (!isDecimalValue(text)) {
					evt.preventDefault();
					return false;
				}
				break;
			}
		}

		onPaste && onPaste(evt);
	}

	function isValueEmpty(val) {
		// 0 is not considered as "empty"
		return isNil(val) || val.toString().trim() === '';
	}

	return (
		<StyledTextInputBox
			className={styleName}
			children={
				<>
					<Label>{!isValueEmpty(value) && !alwaysDisplayPlaceholder ? '' : placeholderText}</Label>
					<Input
						type={type}
						value={value}
						hideClearButton
						onChange={handleOnchange}
						onPaste={handleOnPaste}
						suffix={suffix}
						{...extraProps}
					/>
				</>
			}
		/>
	);
}

export default TextInputBox;

const StyledTextInputBox = styled(FormField)`
	display: inline-flex;
	// background-color: var(--neutrals-00white);
	margin: 0;
	/* Label styling (when control has focus) */
	input {
		height: var(--px-45);
	}
	/* Hide arrows for numeric inputs */
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`;
